export default "__VITE_ASSET__12959819__"